import { MixerIcon, MixerIconBG, MyMixes, playButton, PlaylistIcon, SaveMix } from "../Assets/svg";
import { useTranslation } from "react-i18next";

export const GetText = ({ text }) => {
    const { t } = useTranslation();
    // Map plain text to translation keys for backward compatibility
    const translationMap = {
        "Play": "player.play",
        "Pause": "player.pause",
        "Save Mix": "modals.saveMix",
        "My Playlist": "header.playlist",
        "Timer": "player.timer",
        "Mixer": "player.mixer",
        "Add to Playlist": "playlists.addToPlaylist",
        "Repeat": "player.repeat",
        "Shuffle": "player.shuffle"
    };

    const translationKey = translationMap[text] || text;
    const translatedText = isNaN(translationKey) && translationKey !== undefined && translationKey?.includes(".") ? t(translationKey) : text;

    return (
        <p className="playerActionText mt-1" style={{ fontSize: "10px", fontWeight: "300", minWidth: 30, }}>{translatedText}</p>
    );
};

export const PauseIcon = () => (
    <svg width="25px" height="25px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Media / Pause">
            <g id="Vector">
                <path d="M15 5.5V18.5C15 18.9647 15 19.197 15.0384 19.3902C15.1962 20.1836 15.816 20.8041 16.6094 20.9619C16.8026 21.0003 17.0349 21.0003 17.4996 21.0003C17.9642 21.0003 18.1974 21.0003 18.3906 20.9619C19.184 20.8041 19.8041 20.1836 19.9619 19.3902C20 19.1987 20 18.9687 20 18.5122V5.48777C20 5.03125 20 4.80087 19.9619 4.60938C19.8041 3.81599 19.1836 3.19624 18.3902 3.03843C18.197 3 17.9647 3 17.5 3C17.0353 3 16.8026 3 16.6094 3.03843C15.816 3.19624 15.1962 3.81599 15.0384 4.60938C15 4.80257 15 5.03534 15 5.5Z" stroke="#f7ba31" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M4 5.5V18.5C4 18.9647 4 19.197 4.03843 19.3902C4.19624 20.1836 4.81599 20.8041 5.60938 20.9619C5.80257 21.0003 6.0349 21.0003 6.49956 21.0003C6.96421 21.0003 7.19743 21.0003 7.39062 20.9619C8.18401 20.8041 8.8041 20.1836 8.96191 19.3902C9 19.1987 9 18.9687 9 18.5122V5.48777C9 5.03125 9 4.80087 8.96191 4.60938C8.8041 3.81599 8.18356 3.19624 7.39018 3.03843C7.19698 3 6.96465 3 6.5 3C6.03535 3 5.80257 3 5.60938 3.03843C4.81599 3.19624 4.19624 3.81599 4.03843 4.60938C4 4.80257 4 5.03534 4 5.5Z" stroke="#f7ba31" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
            </g>
        </g>
    </svg>
);

export const PlayIcon = () => (
    <svg width="25px" height="25px" id="Layer_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51.57 65.13">
        <g id="Layer_1-2">
            <path fill="none" stroke="#25e544" strokeWidth={'5px'} strokeMiterlimit={10} d="m47.18,36.15L9.26,61.88c-2.87,1.95-6.76-.11-6.76-3.58V6.83c0-3.47,3.88-5.53,6.76-3.58l37.92,25.73c2.53,1.72,2.53,5.44,0,7.16Z" />
        </g>
    </svg>
);

export const TimerIcon = () => (
    <svg width="25px" height="25px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.36 25.36">
        <g id="Layer_2" data-name="Layer 2">
            <g id="Sounds"><circle class="cls-1" fill="#fff" cx="12.68" cy="12.68" r="12.18" />
                <path class="cls-2" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" d="M20.33,16.19l-6.17-3.27a1.94,1.94,0,0,0,0-.24,1.48,1.48,0,0,0-.84-1.34L12.57,3.1l-.78,8.38a1.5,1.5,0,0,0,.89,2.7,1.47,1.47,0,0,0,.92-.32Z" />
            </g>
        </g>
    </svg>
);

export const AddPlaylistIcon = () => (
    <svg width="25px" height="25px" id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80.57 69.69">
        <g id="Layer_1-2" data-name="Layer 1">
            <path style={{ fill: '#fff' }} d="M2.83,5.65h74.91c1.56,0,2.83-1.27,2.83-2.83s-1.27-2.83-2.83-2.83H2.83C1.27,0,0,1.27,0,2.83s1.27,2.83,2.83,2.83ZM2.83,28.27h69.26c1.56,0,2.83-1.27,2.83-2.83s-1.27-2.83-2.83-2.83H2.83c-1.56,0-2.83,1.27-2.83,2.83s1.27,2.83,2.83,2.83ZM1.71,50.88h36.85c.95,0,1.71-1.27,1.71-2.83s-.77-2.83-1.71-2.83H1.71c-.95,0-1.71,1.27-1.71,2.83s.77,2.83,1.71,2.83ZM63.79,69.69h3.43c.87,0,1.58-.71,1.58-1.58v-24.33c0-.87-.71-1.58-1.58-1.58h-3.43c-.87,0-1.58.71-1.58,1.58v24.33c0,.87.71,1.58,1.58,1.58ZM51.76,54.23v3.43c0,.87.71,1.58,1.58,1.58h24.33c.87,0,1.58-.71,1.58-1.58v-3.43c0-.87-.71-1.58-1.58-1.58h-24.33c-.87,0-1.58.71-1.58,1.58Z" />
        </g>
    </svg>
);

export const RepeatIcon = ({ isActive }) => (
    <svg width="25px" height="25px" id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 82.45 72.11">
        <g id="Layer_1-2" data-name="Layer 1">
            <g>
                <path style={{ fill: isActive ? '#25e544' : '#fff' }} d="M82.45,21.91l-5.69,14.69-14.68-5.69,8.01-4.06c-2.97-9.74-11.66-18.17-21.66-20.44-15.53-3.52-30.29,4.34-36.09,19.09l-5.25-1.5C14.58,2.47,39.94-6.51,59.67,5.13c7.7,4.54,12.59,11.46,15.94,19.61l6.84-2.83Z" />
                <path style={{ fill: isActive ? '#25e544' : '#fff' }} d="M19.9,41.35l-7.94,4c8.77,27.55,48.49,28.37,57.71.73l5.19,1.44c-1.74,7.86-7.93,14.9-14.71,19.14-19.68,12.28-46.22,2.96-53.04-19.15l-7.1,2.37,5.22-14.22,14.68,5.69Z" />
            </g>
        </g>
    </svg>
);

export const ShuffleIcon = ({ isActive }) => (
    <svg width="25px" height="25px" id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 93.21 65.48">
        <g id="Layer_1-2" data-name="Layer 1">
            <g>
                <path style={{ fill: isActive ? '#25e544' : '#fff' }} d="M19.32,9.99c6.15.83,16.77,6.16,21.4,10.44,6.02,5.56,7.21,12.04,11.95,17.9,7.19,8.87,19.68,13.04,30.82,12.45l-6.91-6.57,2.42-3.14c2.81,1.6,14.09,9.66,14.1,12.21,0,2.98-11.17,10.32-14.1,12.2l-2.42-3.14,6.91-6.57c-4.19.04-8.91-.48-12.97-1.47-30.87-7.55-20.9-36.43-58.19-40.31-3.82-.4-15.85,1.79-10.93-4,5.65.54,12.45-.74,17.91,0Z" />
                <path style={{ fill: isActive ? '#25e544' : '#fff' }} d="M83.49,15.94l-.5-1.98c-7.19.63-14.27,1.71-20.7,5.18-3.37,1.82-6.92,5.9-9.64,7.28-1.76.89-1.89.18-2.99-1.02-1.11-4.29,11.78-11.24,15.24-12.6,6.24-2.45,11.84-3.35,18.58-2.81l-6.48-6.94c-1.23-.94.25-2.78,1.06-2.99,3.17-.82,12.7,8.81,15.13,11.42.2,2.51-12.75,13.07-15.16,12.45-.54-.14-1.81-1.61-1.51-2.47l6.95-5.51Z" />
                <path style={{ fill: isActive ? '#25e544' : '#fff' }} d="M18.32,50.78c3.48-.47,10.88-3.91,14.12-5.78,3.77-2.17,6.63-6.77,11.25-6.16-.9,6.47-10.45,11.85-16.38,13.96-1.69.6-9.87,2.95-10.98,2.95H1.41c-1.87,0-1.87-4.98,0-4.98,5.1,0,12.16.64,16.92,0Z" />
            </g>
        </g>
    </svg>
);

export const MixerSvgIcon = () => (
    <svg id="Layer_2" width="25px" height="25px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 65.13 65.13">
        <g id="Layer_1-2">
            <line fill="none" stroke="#25e544" strokeLinecap="round" strokeMiterlimit={10} strokeWidth={'5px'} x1="2.5" y1="62.63" x2="2.5" y2="14.89" />
            <line fill="none" stroke="#25e544" strokeLinecap="round" strokeMiterlimit={10} strokeWidth={'5px'} x1="17.53" y1="62.63" x2="17.53" y2="29.76" />
            <line fill="none" stroke="#25e544" strokeLinecap="round" strokeMiterlimit={10} strokeWidth={'5px'} x1="32.57" y1="62.63" x2="32.57" y2="2.5" />
            <line fill="none" stroke="#25e544" strokeLinecap="round" strokeMiterlimit={10} strokeWidth={'5px'} x1="47.6" y1="62.63" x2="47.6" y2="19.85" />
            <line fill="none" stroke="#25e544" strokeLinecap="round" strokeMiterlimit={10} strokeWidth={'5px'} x1="62.63" y1="62.63" x2="62.63" y2="39.67" />
        </g>
    </svg>
);

export const PlayPauseButton = ({ isActive, isPlaying, handleClick }) => {
    const isPaused = isActive && isPlaying;
    const isResumable = isActive && !isPlaying;

    return (
        <button onClick={handleClick}
            className={`playerAction ${isActive ? (isPlaying ? "pause-btn active" : "play-btn active") : ""}`}>
            {!isActive && <img src={playButton} alt="Play" className="playerActionIcon" />}
            {isPaused && <PauseIcon />}
            {isResumable && <PlayIcon />}
            <GetText text={isPaused ? "Pause" : "Play"} />
        </button>
    );
};

export const SaveMixButton = ({ handleClick }) => (
    <button className="playerAction" onClick={handleClick}>
        <img src={SaveMix} alt="saved mix" className="playerActionIcon" />
        <GetText text="Save Mix" />
    </button>
);

export const PlaylistButton = ({ handleClick }) => (
    <button className="playerAction" onClick={handleClick}>
        <img src={MyMixes} alt="my mix" className="playerActionIcon" />
        <GetText text="My Mix" />
    </button>
);

export const TimerButton = ({ handleClick, timer }) => (
    <button className="playerAction" onClick={handleClick}>
        <TimerIcon />
        <GetText text={timer} />
    </button>
);

export const ShareMixButton = ({ isActive, handleClick }) => (
    <button className={`playerAction ${isActive && 'active'}`} onClick={handleClick}>
        {isActive ? <MixerSvgIcon /> : <img width={25} src={MixerIcon} alt="Mixer Icon" />}
        <GetText text="Mixer" />
    </button >
);

export const AddPlaylistButton = ({ isActive, handleClick }) => (
    <button className={`playerAction px-2`} onClick={handleClick}>
        <AddPlaylistIcon />
        <GetText text="Add to Playlist" />
    </button >
);

export const RepeatButton = ({ isActive, handleClick }) => (
    <button className={`playerAction ${isActive ? "active" : ""}`} onClick={handleClick}>
        <RepeatIcon isActive={isActive} />
        <GetText text="Repeat" />
    </button >
);

export const ShuffleButton = ({ isActive, handleClick }) => (
    <button className={`playerAction ${isActive ? "active" : ""}`} onClick={handleClick}>
        <ShuffleIcon isActive={isActive} />
        <GetText text="Shuffle" />
    </button >
);


